import ReactPixel from 'react-facebook-pixel';

// TikTok Pixel wrapper (id tomado del snippet de index.html: GTM/TikTok script usa CPFJN53C77UFEMG2563G)
// Si en futuro cambia el ID, centralizarlo aquí.
const TIKTOK_PIXEL_ID = 'CPFJN53C77UFEMG2563G';

export function initTikTokPixel() {
  try {
    // El snippet en index.html ya define ttq y hace load + page(); aquí sólo validamos existencia
    if (window.ttq && typeof window.ttq.page === 'function') {
      // Se podría forzar un pageView adicional solo si se requiere validar carga tardía.
      // window.ttq.page(); // opcional (evitamos duplicar si no hace falta)
      return true;
    }
  } catch (e) {
    // Silencioso: no romper la app si el pixel falla
  }
  return false;
}

export function initPixel() {
  const options = {
    autoConfig: false,
    debug: true,
  };

  ReactPixel.init('1177032203751814', options);
}

export function pageViewPixel() {
  ReactPixel.pageView();
}

export function toSchedulePixel() {
  // FacebookPixels
  ReactPixel.trackCustom('HelixAgenda');
  ReactPixel.trackCustom('HelixFinalizar');
  ReactPixel.trackCustom('Schedule');
  // GooglePixels
  window.gtag('event', 'conversion',
    { send_to: 'AW-439393550/3m1oCMjL9PIBEI66wtEB' });
}
